import "./SolicitudesTable.css";
import React, { useState, useEffect, useMemo } from "react";
import { useTable, usePagination } from "react-table";
import Loading from "../0. Utilidades/loadingSpinner";

function normalizeString(str) {
  return str
    ? str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
    : "";
}

function SolicitudesTable() {
  const [searchQuery, setSearchQuery] = useState("");
  const [maestras, setMaestras] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch(
      `${process.env.REACT_APP_BASE_API}api/formularios/comunidades/maestras/`,
    )
      .then((response) => response.json())
      .then((data) => {
        setMaestras(data);
        setIsLoading(false);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const columns = useMemo(
    () => [
      { Header: "Fecha ingreso", accessor: "fecha_ingreso" }, // NEW
      { Header: "Perfil", accessor: "perfil" },
      
      { Header: "Comentarios", accessor: "estado" },
    ],
    [],
  );

  const filteredData = useMemo(() => {
    const normalizedSearchTerm = normalizeString(searchQuery);
    return maestras
      .filter((maestra) => {
        const fullName = normalizeString(`${maestra.nombre}`.toLowerCase());
        return (
          fullName.includes(normalizedSearchTerm) ||
          normalizeString(maestra.comuna?.toLowerCase()).includes(normalizedSearchTerm) ||
          normalizeString(maestra.oficio?.toLowerCase()).includes(normalizedSearchTerm) ||
          normalizeString(maestra.fecha_ingreso?.toLowerCase()).includes(normalizedSearchTerm) // NEW
        );
      })
      .map((maestra) => {
        const comuna = maestra.comuna || "—";
        const oficio = maestra.oficio || "—";

        return {
          ...maestra,

          // Render name + badges (comuna = danger, oficio = warning) right next to the name
          perfil: (
            <div className="perfil-cell">
              <span className="perfil-name">{maestra.nombre}</span>
                <div>
                  <span className="badge bg-danger">{comuna}</span>
                  <span className="badge bg-warning text-dark ms-2">{oficio}</span>
                </div>
            </div>
          ),

          // Backend should already send a formatted string (e.g. "12 marzo 2024" or "12 March 2024")
          // We keep it as-is to avoid timezone issues and avoid new Date().
          fecha_ingreso: maestra.fecha_ingreso || "—",

          estado: `${maestra.estado ? maestra.estado : "-----"}`,
        };
      });
  }, [maestras, searchQuery]);

  const {
  getTableProps,
  getTableBodyProps,
  headerGroups,
  prepareRow,
  page,
  canPreviousPage,
  canNextPage,
  pageOptions,
  nextPage,
  previousPage,
  setPageSize,
  state: { pageIndex, pageSize },
} = useTable(
  {
    columns,
    data: filteredData,
    initialState: { pageIndex: 0, pageSize: 5 },
  },
  usePagination,
);


  const handleRowClick = (rut) => {
    window.location.href = `/api/formularios/ver_maestra/${rut}/`;
  };

  return (
    <div className="solicitudes-table-container capsule">
      <h5>Postulaciones a la Comunidad</h5>
      <div className="solicitudes-table-wrapper">
        <div className="solicitudes-table">
          <div className="solicitudes-search-bar">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                type="button"
                className="clear-search-button"
                onClick={() => setSearchQuery("")}
              >
                &times;
              </button>
            )}
          </div>

          {isLoading ? (
            <Loading />
          ) : (
            <>
              <div className="solicitudes-pagination">
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  {[5, 10, 20, 30, 40, 50].map((size) => (
                    <option key={size} value={size}>
                      Mostrar {size}
                    </option>
                  ))}
                </select>
                <button
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                >
                  {"<"}
                </button>
                <span>
                  {" "}
                  Página {pageIndex + 1} de {pageOptions.length}{" "}
                </span>
                <button onClick={() => nextPage()} disabled={!canNextPage}>
                  {">"}
                </button>
              </div>
              <table {...getTableProps()} className="table table-striped">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th {...column.getHeaderProps()}>
                          {column.render("Header")}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr
                        {...row.getRowProps()}
                        onClick={() => handleRowClick(row.original.rut)}
                        style={{ cursor: "pointer" }}
                      >
                        {row.cells.map((cell) => {
                          return (
                            <td {...cell.getCellProps()}>
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SolicitudesTable;
